const decrypt = (salt: string, encoded: string): string => {
  const textToChars = (text: string) => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = (code: number) => textToChars(salt).reduce((a, b) => a ^ b, code);

  return encoded
    .match(/.{1,2}/g)!
    .map(hex => parseInt(hex, 16))
    .map(applySaltToChar)
    .map(charCode => String.fromCharCode(charCode))
    .join('');
};

const removeExtraSpaces = (value: string): string => {
  return value?.replace(/ +/g, ' ');
};

export { decrypt, removeExtraSpaces };